import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";
import AssegnaCompitoDialog from "@/components/AssegnaCompitoDialog";
import { ListTodo, Plus, CheckCircle2, Circle, Trash2 } from "lucide-react";

export default function CompitiPratica({ pratica, senzaCornice }) {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data: compiti } = useQuery({
    queryKey: ["compiti", "pratica", pratica?.id],
    queryFn: async () => (await api.get(`/compiti?pratica_id=${pratica.id}`)).data,
    enabled: !!pratica?.id,
  });
  const aggiorna = () => {
    qc.invalidateQueries({ queryKey: ["compiti"] });
    qc.invalidateQueries({ queryKey: ["mio-giorno"] });
  };
  const spunta = async (c) => {
    try { await api.patch(`/compiti/${c.id}`, { stato: c.stato === "fatto" ? "aperto" : "fatto" }); aggiorna(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  const elimina = async (c) => {
    if (!window.confirm(`Eliminare "${c.titolo}"?`)) return;
    try { await api.delete(`/compiti/${c.id}`); toast.success("Compito eliminato"); aggiorna(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  const lista = compiti || [];

  return (
    <div className={senzaCornice ? "" : "bg-white border border-[#1A2B4A]/10 rounded-sm p-4"} data-testid="compiti-pratica">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <ListTodo className="w-4 h-4 text-[#C9A84C]" />
          {!senzaCornice && <h3 className="font-serif text-lg text-[#1A2B4A]">Compiti</h3>}
        </div>
        <button data-testid="pratica-assegna-compito" onClick={() => setOpen(true)}
          className="inline-flex items-center gap-1.5 text-xs border border-[#1A2B4A]/20 px-2 py-1 rounded-sm hover:border-[#C9A84C]">
          <Plus className="w-3.5 h-3.5" /> Assegna
        </button>
      </div>

      {lista.length === 0 ? (
        <p className="text-sm text-[#8a93a6]">Nessun compito per questa pratica.</p>
      ) : (
        <ul className="space-y-1.5">
          {lista.map((c) => (
            <li key={c.id} data-testid={`pratica-compito-${c.id}`} className="flex items-start gap-2 group">
              <button data-testid={`pratica-compito-done-${c.id}`} onClick={() => spunta(c)}
                className="mt-0.5 text-[#4a5568] hover:text-[#276749]">
                {c.stato === "fatto" ? <CheckCircle2 className="w-4 h-4 text-[#276749]" /> : <Circle className="w-4 h-4" />}
              </button>
              <div className="min-w-0 flex-1">
                <span className={`text-sm break-words ${c.stato === "fatto" ? "text-[#8a93a6] line-through" : "text-[#1A2B4A]"}`}>{c.titolo}</span>
                <span className="block text-[11px] text-[#8a93a6]">
                  {c.assegnato_a_nome ? `${c.assegnato_a_nome}` : ""}
                  {c.scadenza ? ` · ${c.scadenza.slice(0, 10).split("-").reverse().join("/")}` : ""}
                  {c.tipo === "appuntamento" ? " · appuntamento" : c.tipo === "promemoria" ? " · promemoria" : ""}
                </span>
              </div>
              <button data-testid={`pratica-compito-del-${c.id}`} onClick={() => elimina(c)}
                className="opacity-0 group-hover:opacity-100 text-[#9b2c2c]/70 hover:text-[#9b2c2c]"><Trash2 className="w-3.5 h-3.5" /></button>
            </li>
          ))}
        </ul>
      )}

      {open && (
        <AssegnaCompitoDialog onClose={() => setOpen(false)} onSaved={aggiorna}
          pratica={pratica} />
      )}
    </div>
  );
}
